/**
 * @Author Heriberto Monterrubio <heri185403@gmail.com>
 * @Date 2020-Oct-11
 *
 **/

// eslint-disable-next-line no-unused-vars
import {validateCURP} from "../core/utils";

const fiscalContactFormValidator = {
    input: {
        required: value => !!value || 'El campo es requerido.',
    },
    /*username: {
        required: value => !!value || 'El campo Usuario es requerido.',
            min_max: v => v.length >=4 && v.length<=15 || 'Debe ser una cadena de entre 4 y 15 caracteres.',
            valid_char: v => /^\w+$/.test(v) || 'Únicamente son válidos caracteres alfanuméricos y/o guión bajo'
    },
    email: {
        required: value => !!value || 'El campo Email es requerido.',
            valid_email: v =>  /\S+@\S+\.\S+/.test(v) || 'El email no es válido'
    },
    phone: {
        required: value => !!value || 'El campo Email es requerido.',
        digits_10: v => v.length === 10 || 'El número de teléfono debe ser de 10 dígitos'
    },
    password: {
        required: value => !!value || 'El campo contraseña es requerido.',
        min: v => v.length >= 8 || 'Se requiere al menos 8 caracteres',
        passwordMatch: (confirmPassword, password) => confirmPassword === password || 'Las contraseñas no cioniciden'
    },
    curp: {
        required: value => !!value || 'El campo CURP es requerido.',
        ws_validate: curp => validateCURP(curp) || 'Ingresa una CURP válida '
    },
    name: {
        required: value => !!value || 'El campo Nombre es requerido.',
    },
    lastname_pat: {
        required: value => !!value || 'El campo Apellido paterno es requerido.',
    },*/
    rfc: {
        validate: rfc => (!rfc || !!rfc && /^([A-ZÑ&]{3,4}) ?(?:- ?)?(\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])) ?(?:- ?)?([A-Z\d]{2})([A\d])$/.test(rfc.toUpperCase())) || 'Ingresa un RFC válido.',
	required: value => !!value || 'El campo es requerido.'
    }
}

export default fiscalContactFormValidator;
